





import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import _ from 'lodash';
import reportModule from '@/store/modules/common/report.module';
import { Table, TableHeader } from '@/store/models';
import VTable from '@/components/items/VTable.vue';
import Mixin from '@/mixin';

@Component({
  name: 'ReportChart',
  components: { VTable }
})
export default class ReportChart extends Mixin {
  get reportIndividualData() {
    return reportModule.reportIndividualData;
  }

  get reportDataDetail() {
    return this.reportIndividualData.data;
  }

  get filterReport() {
    let reportData: any[];
    if (reportModule.reportCoachClientId) {
      reportData = [
        ...this.reportDataDetail.filter(
          rp => rp['coachClientId'] === reportModule.reportCoachClientId
        )
      ];
    } else reportData = [...this.reportDataDetail];

    if (reportModule.reportSorting) {
      reportData = [
        ..._.orderBy(
          reportData,
          [reportModule.reportSorting, 'id'],
          ['desc', 'asc']
        )
      ];
    }

    let currentDisplayName = '';
    return reportData.map(rp => {
      if (
        `${rp['coachClient']['firstName']} ${rp['coachClient']['lastName']}` ===
        currentDisplayName
      ) {
        return { ...rp, name: '' };
      } else {
        currentDisplayName = `${rp['coachClient']['firstName']} ${rp['coachClient']['lastName']}`;
        return { ...rp, name: currentDisplayName };
      }
    });
  }

  get tableData() {
    return {
      headers: [
        {
          name: 'Employee Name',
          width: 'width--20',
          order: false,
          query: 'name'
        } as TableHeader,
        {
          name: 'Action Items',
          width: 'width--60',
          order: false,
          query: 'message'
        } as TableHeader,
        {
          name: 'Action Completion Rate',
          width: 'width--20',
          order: false,
          query: 'points'
        } as TableHeader
      ],
      property: {
        edit: false,
        delete: false,
        index: false,
        func: () => {},
        overflow_y: true
      },
      values: { data: this.filterReport }
    } as Table;
  }
}
